import type { IFlex } from "./types"
import css from './index.module.scss'


/** Компонент Flex */
export const Flex = ({
    id,
    children,
    className,

    width,
    maxWidth,
    height,
    maxHeight,
    padding,
    background,

    gap,
    flexWrap,
    flexGrow,
    flexBasis,
    flexDirection = 'column',

    alignItems,
    justifyContent,

    textAlign,
    overflowY,
    
    isRendered = true,
    
    onClick
}: IFlex) => {
    /** Стили компоненты */
    const componentStyle: React.CSSProperties = {
        width: width,
        maxWidth: maxWidth,
        height: height,
        maxHeight: maxHeight,
        padding: padding,
        background: background,

        gap: gap,
        flexWrap: flexWrap,
        flexGrow: flexGrow,
        flexBasis: flexBasis,
        flexDirection: flexDirection,

        alignItems: alignItems,
        justifyContent: justifyContent,

        textAlign: textAlign,
        overflowY: overflowY,
    }

    return <>
        {isRendered && 
            <div id={id} style={componentStyle} className={`${css['container']} ${className || ''}`.trim()} onClick={onClick}>
                {children}
            </div>
        }
    </>
}